import { useMemo } from 'react'

import { Box, Modal, Treeview } from '@fairfashion/design-system'

import { BlockchainTreeModalProps } from './blockchain-tree-modal.types'
import { translateObject } from './blockchain-tree-modal.utils'

export const BlockchainTreeModal = ({
  data,
  linkUrlExplorer,
  authInfo,
  open,
  setOpen,
}: BlockchainTreeModalProps) => {
  const translatedObj = useMemo(
    () => translateObject(data, linkUrlExplorer, authInfo),
    [data],
  )

  if (!data) return null

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title="Blockchain"
      width="900px"
      maxWidth="90%"
    >
      <Box padding={2}>
        <Treeview obj={translatedObj} />
      </Box>
    </Modal>
  )
}
